import { ALTERNATE_WIDTH, DEVICE_DESKTOP, DEVICE_MOBILE } from '../../../utils/constants';
import {
  ACTIVATE_LOADER,
  CLEAR_STORE,
  DEACTIVATE_LOADER,
  SCROLL_INTO_VIEW,
  SCROLL_TO_TOP,
  SWITCH_DEVICE,
  TOGGLE_SIDEBAR
} from '../../action-contants';
import { scrollOnFormError } from '../../../utils/library';

const INITIAL_STATE = {
  loaderState: false,
  scroll: Date.now(),
  sidebarVisibility: false,
  loaderConfig: null,
  device: window.innerWidth <= ALTERNATE_WIDTH ? DEVICE_MOBILE : DEVICE_DESKTOP
};

export default function uiTriggerState(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CLEAR_STORE: {
      return INITIAL_STATE;
    }
    case ACTIVATE_LOADER:
      return { ...state, loaderState: true, loaderConfig: action.data };
    case DEACTIVATE_LOADER:
      return { ...state, loaderState: false };
    case SCROLL_TO_TOP:
      return { ...state, scroll: Date.now() };
    case SCROLL_INTO_VIEW:
      scrollOnFormError(action.data);
      return state;
    case TOGGLE_SIDEBAR:
      return { ...state, sidebarVisibility: !state.sidebarVisibility };
    case SWITCH_DEVICE:
      return { ...state, device: action.device };
    default:
      return state;
  }
}
